(function () {
    'use strict';

    angular.module('collaterate.interceptors', ['collaterate.panels']);
}());
